// tslint:disable
/**
 * SendHub Integrations
 * https://integrations.sendhub.com\'s API for frontend use.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@sendhub.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url'
import { Configuration } from './configuration'
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from './base'

/**
 *
 * @export
 * @enum {string}
 */
export enum ConditionOperator {
  OR = 'OR',
  AND = 'AND',
}

/**
 *
 * @export
 * @interface ExampleWebhookBody
 */
export interface ExampleWebhookBody {
  /**
   *
   * @type {string}
   * @memberof ExampleWebhookBody
   */
  foo: string
}
/**
 *
 * @export
 * @enum {string}
 */
export enum FollowUpBossEvent {
  PeopleDeleted = 'peopleDeleted',
  PeopleCreated = 'peopleCreated',
  PeopleUpdated = 'peopleUpdated',
  TasksCreated = 'tasksCreated',
}

/**
 *
 * @export
 * @interface FollowUpBossWebhookBody
 */
export interface FollowUpBossWebhookBody {
  /**
   *
   * @type {string}
   * @memberof FollowUpBossWebhookBody
   */
  eventId: string
  /**
   *
   * @type {string}
   * @memberof FollowUpBossWebhookBody
   */
  eventCreated: string
  /**
   *
   * @type {FollowUpBossEvent}
   * @memberof FollowUpBossWebhookBody
   */
  event: FollowUpBossEvent
  /**
   *
   * @type {Array<number>}
   * @memberof FollowUpBossWebhookBody
   */
  resourceIds: Array<number>
  /**
   *
   * @type {string}
   * @memberof FollowUpBossWebhookBody
   */
  uri: string | null
}
/**
 * Individual integration (eg. Sync Contacts, Send Message, etc.)
 * @export
 * @interface Integration
 */
export interface Integration {
  /**
   *
   * @type {string}
   * @memberof Integration
   */
  id: string
  /**
   * The name of this integration (eg. Sync Contacts). Usually preceded by the IntegrationGroup.name such as Follow Up Boss.
   * @type {string}
   * @memberof Integration
   */
  name: string
  /**
   * Id of the related IntegrationGroup.
   * @type {string}
   * @memberof Integration
   */
  integrationGroupId: string
  /**
   * True if this integration requires a SendHub Admin user to configure.
   * @type {boolean}
   * @memberof Integration
   */
  requiresAdmin: boolean
  /**
   * User-facing description of this integration.
   * @type {string}
   * @memberof Integration
   */
  description: string
  /**
   * Timestamp this record was created
   * @type {string}
   * @memberof Integration
   */
  createdAt?: string
  /**
   * Timestamp this record was last updated
   * @type {string}
   * @memberof Integration
   */
  updatedAt?: string
}
/**
 * Individual integration (eg. Sync Contacts, Send Message, etc.)
 * @export
 * @interface Integration1
 */
export interface Integration1 {
  /**
   *
   * @type {string}
   * @memberof Integration1
   */
  id: string
  /**
   * The name of this integration (eg. Sync Contacts). Usually preceded by the IntegrationGroup.name such as Follow Up Boss.
   * @type {string}
   * @memberof Integration1
   */
  name: string
  /**
   * Id of the related IntegrationGroup.
   * @type {string}
   * @memberof Integration1
   */
  integrationGroupId: string
  /**
   * True if this integration requires a SendHub Admin user to configure.
   * @type {boolean}
   * @memberof Integration1
   */
  requiresAdmin: boolean
  /**
   * User-facing description of this integration.
   * @type {string}
   * @memberof Integration1
   */
  description: string
  /**
   * Timestamp this record was created
   * @type {string}
   * @memberof Integration1
   */
  createdAt?: string
  /**
   * Timestamp this record was last updated
   * @type {string}
   * @memberof Integration1
   */
  updatedAt?: string
}
/**
 * A user\'s configuration of an integration
 * @export
 * @interface IntegrationConfig
 */
export interface IntegrationConfig {
  /**
   *
   * @type {string}
   * @memberof IntegrationConfig
   */
  id: string
  /**
   * The ID of the SendHub User that created this config.
   * @type {string}
   * @memberof IntegrationConfig
   */
  userId: string
  /**
   * Whether or not this integration config is enabled.
   * @type {boolean}
   * @memberof IntegrationConfig
   */
  enabled: boolean
  /**
   * The ID of the integration this config is for.
   * @type {string}
   * @memberof IntegrationConfig
   */
  integrationId: string
  /**
   * User-configurable settings for the related integration.
   * @type {IntegrationConfigSettingsSendhubWebhookRepeater | IntegrationConfigSettingsFollowUpBossSyncContacts | IntegrationConfigSettingsFollowUpBossActionPlanSMS | IntegrationConfigSettingsFollowUpBossActionPlanSMSLegacy | IntegrationConfigSettingsJazzHRSyncApplicants | IntegrationConfigSettingsFollowUpBossSyncSms}
   * @memberof IntegrationConfig
   */
  settings:
    | IntegrationConfigSettingsSendhubWebhookRepeater
    | IntegrationConfigSettingsFollowUpBossSyncContacts
    | IntegrationConfigSettingsFollowUpBossActionPlanSMS
    | IntegrationConfigSettingsFollowUpBossActionPlanSMSLegacy
    | IntegrationConfigSettingsJazzHRSyncApplicants
    | IntegrationConfigSettingsFollowUpBossSyncSms
  /**
   *
   * @type {string}
   * @memberof IntegrationConfig
   */
  serviceAccountId?: string
}
/**
 * Creation payload for an IntegrationConfig
 * @export
 * @interface IntegrationConfigCreationPayload
 */
export interface IntegrationConfigCreationPayload {
  /**
   * Whether or not this integration config is enabled.
   * @type {boolean}
   * @memberof IntegrationConfigCreationPayload
   */
  enabled: boolean
  /**
   * The ID of the integration this config is for.
   * @type {string}
   * @memberof IntegrationConfigCreationPayload
   */
  integrationId: string
  /**
   * User-configurable settings for the related integration.
   * @type {IntegrationConfigSettingsFollowUpBossSyncContacts | IntegrationConfigSettingsFollowUpBossActionPlanSMS | IntegrationConfigSettingsJazzHRSyncApplicants | IntegrationConfigSettingsFollowUpBossSyncSms | IntegrationConfigSettingsSendhubWebhookRepeater}
   * @memberof IntegrationConfigCreationPayload
   */
  settings:
    | IntegrationConfigSettingsFollowUpBossSyncContacts
    | IntegrationConfigSettingsFollowUpBossActionPlanSMS
    | IntegrationConfigSettingsJazzHRSyncApplicants
    | IntegrationConfigSettingsFollowUpBossSyncSms
    | IntegrationConfigSettingsSendhubWebhookRepeater
  /**
   *
   * @type {string}
   * @memberof IntegrationConfigCreationPayload
   */
  serviceAccountId?: string
}
/**
 * IntegrationConfig settings required for the Follow Up Boss \"Action Plan SMS\" integration
 * @export
 * @interface IntegrationConfigSettingsFollowUpBossActionPlanSMS
 */
export interface IntegrationConfigSettingsFollowUpBossActionPlanSMS {
  /**
   * Start of the daily send window, as a 24-hour local time-of-day (HH:mm) interpreted in `timezone`.
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossActionPlanSMS
   */
  sendWindowStart: string
  /**
   * End of the daily send window, as a 24-hour local time-of-day (HH:mm) interpreted in `timezone`. May be earlier than the start for a window that spans midnight.
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossActionPlanSMS
   */
  sendWindowEnd: string
  /**
   * IANA timezone the send window is interpreted in. Sourced from the Follow Up Boss account (/me); the UI defaults it to the browser\'s timezone.
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossActionPlanSMS
   */
  timezone: string
  /**
   * Specifies which of the contact\'s phone number(s) to send to.
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossActionPlanSMS
   */
  numberFilter: string
}
/**
 * Legacy (pre-send-window) IntegrationConfig settings for the Follow Up Boss \"Action Plan SMS\" integration. A single `scheduleFor` timestamp instead of `sendWindowStart`/`sendWindowEnd`/`timezone`. Retained so legacy-shaped data can be represented and tested; `resolveSendWindow` normalizes it into a 1-hour window.
 * @export
 * @interface IntegrationConfigSettingsFollowUpBossActionPlanSMSLegacy
 */
export interface IntegrationConfigSettingsFollowUpBossActionPlanSMSLegacy {
  /**
   * The time to schedule all Action Plan SMS messages for.
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossActionPlanSMSLegacy
   */
  scheduleFor: string
  /**
   * Specifies which of the contact\'s phone number(s) to send to.
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossActionPlanSMSLegacy
   */
  numberFilter: string
}
/**
 * IntegrationConfig settings required for the Follow Up Boss \"Sync Contacts\" integration
 * @export
 * @interface IntegrationConfigSettingsFollowUpBossSyncContacts
 */
export interface IntegrationConfigSettingsFollowUpBossSyncContacts {
  /**
   * The direction to sync contacts. \"SendHub to FUB\" and \"Both\" are coming soon!
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossSyncContacts
   */
  syncDirection: SyncDirectionEnum
  /**
   * How to organize synced contacts.  Tags: Contacts are put in SendHub Groups based on FUB tags Stage: Contacts are put in SendHub Groups based on FUB stage Smart Lists: Contacts are put in SendHub Groups based on FUB Smart Lists
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossSyncContacts
   */
  groupBy: GroupByEnum
}

/**
 * @export
 * @enum {string}
 */
export enum SyncDirectionEnum {
  FUBToSendHub = 'FUB to SendHub',
}
/**
 * @export
 * @enum {string}
 */
export enum GroupByEnum {
  Tags = 'Tags',
  Stage = 'Stage',
  SmartLists = 'Smart Lists',
}

/**
 * IntegrationConfig settings required for the FollowUpBoss \"Sync SMS\" integration
 * @export
 * @interface IntegrationConfigSettingsFollowUpBossSyncSms
 */
export interface IntegrationConfigSettingsFollowUpBossSyncSms {
  /**
   * The direction to sync SMS messages. \"FUB to SendHub\" and \"Both\" are coming soon!
   * @type {string}
   * @memberof IntegrationConfigSettingsFollowUpBossSyncSms
   */
  syncDirection: SyncDirectionEnum
  /**
   * Tag Follow Up Boss people \"SendHub: Opted Out\" (plus a timeline note) when they text STOP, and remove the tag when they opt back in. Treated as true when missing.
   * @type {boolean}
   * @memberof IntegrationConfigSettingsFollowUpBossSyncSms
   */
  syncOptOuts?: boolean
}

/**
 * @export
 * @enum {string}
 */
export enum SyncDirectionEnum {
  SendHubToFUB = 'SendHub to FUB',
}

/**
 * IntegrationConfig settings required for the JazzHR \"Sync Applicants\" integration
 * @export
 * @interface IntegrationConfigSettingsJazzHRSyncApplicants
 */
export interface IntegrationConfigSettingsJazzHRSyncApplicants {
  /**
   * Whether or not to save contacts as \"{LastName}, {FirstName}\".
   * @type {boolean}
   * @memberof IntegrationConfigSettingsJazzHRSyncApplicants
   */
  lastNameFirst: boolean
  /**
   * Array of ConditionGroups that determine which applicants to sync to which SendHub lines.
   * @type {Array<IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroup>}
   * @memberof IntegrationConfigSettingsJazzHRSyncApplicants
   */
  conditionGroups: Array<IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroup>
}
/**
 *
 * @export
 * @interface IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroup
 */
export interface IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroup {
  /**
   *
   * @type {ConditionOperator}
   * @memberof IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroup
   */
  conditionOperator: ConditionOperator
  /**
   * Array of userIds to sync matching applicants to.
   * @type {Array<string>}
   * @memberof IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroup
   */
  lines: Array<string>
  /**
   *
   * @type {Array<IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroupConditions>}
   * @memberof IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroup
   */
  conditions: Array<IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroupConditions>
}
/**
 *
 * @export
 * @interface IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroupConditions
 */
export interface IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroupConditions {
  /**
   * JazzHR Applicant\'s dynamic field to be compared with field2
   * @type {string}
   * @memberof IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroupConditions
   */
  field1: Field1Enum
  /**
   * Operator to compare field1 to field2 with
   * @type {string}
   * @memberof IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroupConditions
   */
  operator: OperatorEnum
  /**
   * Text to compare to field1
   * @type {string}
   * @memberof IntegrationConfigSettingsJazzHRSyncApplicantsConditionGroupConditions
   */
  field2?: string
}

/**
 * @export
 * @enum {string}
 */
export enum Field1Enum {
  ApplicantFirstName = 'applicant.first_name',
  ApplicantLastName = 'applicant.last_name',
  ApplicantProspectPhone = 'applicant.prospect_phone',
  ApplicantApplyDate = 'applicant.apply_date',
  ApplicantJobTitle = 'applicant.job_title',
  JobId = 'job.id',
  JobTeamId = 'job.team_id',
  JobCountryId = 'job.country_id',
  JobCity = 'job.city',
  JobState = 'job.state',
  JobZip = 'job.zip',
  JobDepartment = 'job.department',
  JobDescription = 'job.description',
  JobMinimumSalary = 'job.minimum_salary',
  JobMaximumSalary = 'job.maximum_salary',
  JobNotes = 'job.notes',
  JobOriginalOpenDate = 'job.original_open_date',
  JobType = 'job.type',
  JobStatus = 'job.status',
  JobSendToJobBoards = 'job.send_to_job_boards',
  JobHiringLead = 'job.hiring_lead',
  JobBoardCode = 'job.board_code',
  JobInternalCode = 'job.internal_code',
  JobQuestionnaire = 'job.questionnaire',
}
/**
 * @export
 * @enum {string}
 */
export enum OperatorEnum {
  Equals = 'Equals',
  Contains = 'Contains',
  DoesntEqual = "Doesn't Equal",
  DoesntContain = "Doesn't Contain",
}

/**
 * IntegrationConfig settings required for the SendHub \"Webhook Repeater\" integration
 * @export
 * @interface IntegrationConfigSettingsSendhubWebhookRepeater
 */
export interface IntegrationConfigSettingsSendhubWebhookRepeater {
  /**
   *
   * @type {Array<IntegrationConfigSettingsSendhubWebhookRepeaterUrls>}
   * @memberof IntegrationConfigSettingsSendhubWebhookRepeater
   */
  urls: Array<IntegrationConfigSettingsSendhubWebhookRepeaterUrls>
}
/**
 *
 * @export
 * @interface IntegrationConfigSettingsSendhubWebhookRepeaterUrls
 */
export interface IntegrationConfigSettingsSendhubWebhookRepeaterUrls {
  /**
   *
   * @type {string}
   * @memberof IntegrationConfigSettingsSendhubWebhookRepeaterUrls
   */
  url?: string
  /**
   *
   * @type {Array<SendhubWebhookType>}
   * @memberof IntegrationConfigSettingsSendhubWebhookRepeaterUrls
   */
  webhookTypes?: Array<SendhubWebhookType>
}
/**
 * Error response when an integration enable/disable operation fails
 * @export
 * @interface IntegrationConfigUpdateError
 */
export interface IntegrationConfigUpdateError {
  /**
   * User-facing error message
   * @type {string}
   * @memberof IntegrationConfigUpdateError
   */
  message: string
  /**
   * Machine-readable error code (e.g. invalid_credentials, service_unavailable)
   * @type {string}
   * @memberof IntegrationConfigUpdateError
   */
  code?: string
  /**
   * Field-level errors, when the failure pertains to a specific request field
   * @type {Array<IntegrationConfigUpdateErrorErrors>}
   * @memberof IntegrationConfigUpdateError
   */
  errors?: Array<IntegrationConfigUpdateErrorErrors>
}
/**
 *
 * @export
 * @interface IntegrationConfigUpdateErrorErrors
 */
export interface IntegrationConfigUpdateErrorErrors {
  /**
   * JSON path of the offending field, e.g. \'.body.serviceAccountId\'
   * @type {string}
   * @memberof IntegrationConfigUpdateErrorErrors
   */
  path?: string
  /**
   *
   * @type {string}
   * @memberof IntegrationConfigUpdateErrorErrors
   */
  message?: string
  /**
   *
   * @type {string}
   * @memberof IntegrationConfigUpdateErrorErrors
   */
  errorCode?: string
}
/**
 * Defines a group for multiple integrations to relate to. Typically one group for each 3rd-party service we integrate with (eg. Follow Up Boss, JazzHR, etc.).
 * @export
 * @interface IntegrationGroup
 */
export interface IntegrationGroup {
  /**
   *
   * @type {string}
   * @memberof IntegrationGroup
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof IntegrationGroup
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof IntegrationGroup
   */
  image: string
  /**
   * Timestamp this record was created
   * @type {string}
   * @memberof IntegrationGroup
   */
  createdAt?: string
  /**
   * Timestamp this record was last updated
   * @type {string}
   * @memberof IntegrationGroup
   */
  updatedAt?: string
}
/**
 * Defines a group for multiple integrations to relate to. Typically one group for each 3rd-party service we integrate with (eg. Follow Up Boss, JazzHR, etc.).
 * @export
 * @interface IntegrationGroup1
 */
export interface IntegrationGroup1 {
  /**
   *
   * @type {string}
   * @memberof IntegrationGroup1
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof IntegrationGroup1
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof IntegrationGroup1
   */
  image: string
  /**
   * Timestamp this record was created
   * @type {string}
   * @memberof IntegrationGroup1
   */
  createdAt?: string
  /**
   * Timestamp this record was last updated
   * @type {string}
   * @memberof IntegrationGroup1
   */
  updatedAt?: string
}
/**
 * Username and password to log into SendHub
 * @export
 * @interface LoginPayload
 */
export interface LoginPayload {
  /**
   *
   * @type {string}
   * @memberof LoginPayload
   */
  username: string
  /**
   *
   * @type {string}
   * @memberof LoginPayload
   */
  password: string
  /**
   * Sign into app.SendHub.com too
   * @type {boolean}
   * @memberof LoginPayload
   */
  both?: boolean
}
/**
 * Username and password to log into SendHub
 * @export
 * @interface LoginPayload1
 */
export interface LoginPayload1 {
  /**
   *
   * @type {string}
   * @memberof LoginPayload1
   */
  username: string
  /**
   *
   * @type {string}
   * @memberof LoginPayload1
   */
  password: string
  /**
   * Sign into app.SendHub.com too
   * @type {boolean}
   * @memberof LoginPayload1
   */
  both?: boolean
}
/**
 * Request payload for /v2/auth/logout
 * @export
 * @interface LogoutPayload
 */
export interface LogoutPayload {
  /**
   * Sign out of app.SendHub.com too
   * @type {boolean}
   * @memberof LogoutPayload
   */
  both?: boolean
}
/**
 * Request payload for /v2/auth/logout
 * @export
 * @interface LogoutPayload1
 */
export interface LogoutPayload1 {
  /**
   * Sign out of app.SendHub.com too
   * @type {boolean}
   * @memberof LogoutPayload1
   */
  both?: boolean
}
/**
 *
 * @export
 * @interface NewIntegrationFormPayload
 */
export interface NewIntegrationFormPayload {
  /**
   * First name of the requester
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  firstName?: string
  /**
   * Last name of the requester
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  lastName?: string
  /**
   * Email address of the requester
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  email?: string
  /**
   * Phone number of the requester
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  phone?: string
  /**
   * Name of the requester\'s company
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  companyName?: string
  /**
   * Position of the requester in their company
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  position?: string
  /**
   * Name of the third-party service to be integrated with
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  appName?: string
  /**
   * Short description of the third-party service
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  appDescription?: string
  /**
   * Website of the third-party service
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  appWebsite?: string
  /**
   * Whether the third-party service has an API
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  appHasApi?: AppHasApiEnum
  /**
   * URL of the API documentation of the third-party service
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  appApiDocumentation?: string | null
  /**
   * Type of integration
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  integrationType?: IntegrationTypeEnum
  /**
   * Details of the integration
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  integrationDetails?: string
  /**
   * Desired timeline for the integration
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  desiredTimeline?: string
  /**
   * Budget for the integration
   * @type {number}
   * @memberof NewIntegrationFormPayload
   */
  budget?: number
  /**
   * Additional comments from the requester
   * @type {string}
   * @memberof NewIntegrationFormPayload
   */
  additionalComments?: string
}

/**
 * @export
 * @enum {string}
 */
export enum AppHasApiEnum {
  Yes = 'Yes',
  YesButTheDocsArentHostedOnline = "Yes, but the docs aren't hosted online",
  No = 'No',
  IDontKnow = "I don't know",
}
/**
 * @export
 * @enum {string}
 */
export enum IntegrationTypeEnum {
  SyncContacts = 'Sync Contacts',
  SyncMessages = 'Sync Messages',
  SendMessages = 'Send Messages',
  ChatBot = 'Chat Bot',
  EmailNotificationsForNewMessages = 'Email Notifications for New Messages',
  Other = 'Other',
}

/**
 *
 * @export
 * @interface NewIntegrationFormResponse
 */
export interface NewIntegrationFormResponse {
  /**
   * Message indicating the status of the request
   * @type {string}
   * @memberof NewIntegrationFormResponse
   */
  message?: string
}
/**
 * @type SendhubWebhook
 * @export
 */
export type SendhubWebhook =
  | SendhubWebhookReceivedBlock
  | SendhubWebhookReceivedMessage
  | SendhubWebhookReceivedSubscription
  | SendhubWebhookReceivedSubscriptionConfirmed
  | SendhubWebhookReceivedUnblock
  | SendhubWebhookReceivedUnsubscription
  | SendhubWebhookSentMessage
  | SendhubWebhookTestWebHook

/**
 *
 * @export
 * @interface SendhubWebhookCommonProperties
 */
export interface SendhubWebhookCommonProperties {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookCommonProperties
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookCommonProperties
   */
  requestId?: string
}
/**
 * A webhook that SendHub sends when someone blocks your SendHub number by sending STOP, QUIT, CANCEL, etc.
 * @export
 * @interface SendhubWebhookReceivedBlock
 */
export interface SendhubWebhookReceivedBlock {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookReceivedBlock
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookReceivedBlock
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedBlock
   */
  type?: TypeEnum
  /**
   *
   * @type {SendhubWebhookReceivedBlockData}
   * @memberof SendhubWebhookReceivedBlock
   */
  data?: SendhubWebhookReceivedBlockData
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum {
  ReceivedBlock = 'receivedBlock',
}

/**
 *
 * @export
 * @interface SendhubWebhookReceivedBlockData
 */
export interface SendhubWebhookReceivedBlockData {
  /**
   * The blocked number. Sent by newer SendHub versions; same as block.phone_number.
   * @type {string}
   * @memberof SendhubWebhookReceivedBlockData
   */
  phone_number?: string
  /**
   *
   * @type {SendhubWebhookReceivedBlockDataBlock}
   * @memberof SendhubWebhookReceivedBlockData
   */
  block?: SendhubWebhookReceivedBlockDataBlock
}
/**
 *
 * @export
 * @interface SendhubWebhookReceivedBlockDataBlock
 */
export interface SendhubWebhookReceivedBlockDataBlock {
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedBlockDataBlock
   */
  phone_number?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedBlockDataBlock
   */
  created_at?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedBlockDataBlock
   */
  contact_id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedBlockDataBlock
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedBlockDataBlock
   */
  blocked_user_id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedBlockDataBlock
   */
  message_id?: string
}
/**
 * A webhook that SendHub sends when your SendHub account receives a message
 * @export
 * @interface SendhubWebhookReceivedMessage
 */
export interface SendhubWebhookReceivedMessage {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookReceivedMessage
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookReceivedMessage
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessage
   */
  type?: TypeEnum
  /**
   *
   * @type {SendhubWebhookReceivedMessageData}
   * @memberof SendhubWebhookReceivedMessage
   */
  data?: SendhubWebhookReceivedMessageData
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum {
  ReceivedMessage = 'receivedMessage',
}

/**
 *
 * @export
 * @interface SendhubWebhookReceivedMessageData
 */
export interface SendhubWebhookReceivedMessageData {
  /**
   *
   * @type {SendhubWebhookReceivedMessageDataMessage}
   * @memberof SendhubWebhookReceivedMessageData
   */
  message?: SendhubWebhookReceivedMessageDataMessage
}
/**
 *
 * @export
 * @interface SendhubWebhookReceivedMessageDataMessage
 */
export interface SendhubWebhookReceivedMessageDataMessage {
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  direction?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  user_id?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  deleted?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  text?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  created_at?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  modified_at?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  thread_id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  link?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedMessageDataMessage
   */
  hash?: string
}
/**
 * A webhook that SendHub sends when someone starts sends a group\'s keyword to subscribe a group (but hasn\'t replied YES to confirm yet)
 * @export
 * @interface SendhubWebhookReceivedSubscription
 */
export interface SendhubWebhookReceivedSubscription {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookReceivedSubscription
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscription
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscription
   */
  type?: TypeEnum
  /**
   *
   * @type {SendhubWebhookReceivedSubscriptionData}
   * @memberof SendhubWebhookReceivedSubscription
   */
  data?: SendhubWebhookReceivedSubscriptionData
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum {
  ReceivedSubscription = 'receivedSubscription',
}

/**
 * A webhook that SendHub sends when someone confirms subscribing to a group via the Text-to-join feature
 * @export
 * @interface SendhubWebhookReceivedSubscriptionConfirmed
 */
export interface SendhubWebhookReceivedSubscriptionConfirmed {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmed
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmed
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmed
   */
  type?: TypeEnum
  /**
   *
   * @type {SendhubWebhookReceivedSubscriptionConfirmedData}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmed
   */
  data?: SendhubWebhookReceivedSubscriptionConfirmedData
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum {
  ReceivedSubscriptionConfirmed = 'receivedSubscriptionConfirmed',
}

/**
 *
 * @export
 * @interface SendhubWebhookReceivedSubscriptionConfirmedData
 */
export interface SendhubWebhookReceivedSubscriptionConfirmedData {
  /**
   *
   * @type {SendhubWebhookReceivedSubscriptionDataContact}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedData
   */
  contact?: SendhubWebhookReceivedSubscriptionDataContact
  /**
   *
   * @type {SendhubWebhookReceivedSubscriptionConfirmedDataGroup}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedData
   */
  group?: SendhubWebhookReceivedSubscriptionConfirmedDataGroup
}
/**
 *
 * @export
 * @interface SendhubWebhookReceivedSubscriptionConfirmedDataGroup
 */
export interface SendhubWebhookReceivedSubscriptionConfirmedDataGroup {
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  check_all?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  mediums?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  user_id?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  is_shared?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  date_modified?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  deleted?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  slug?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  text_to_subscribe?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  id_str?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  ttjResponse?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  date_created?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  permissions?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionConfirmedDataGroup
   */
  name?: string
}
/**
 *
 * @export
 * @interface SendhubWebhookReceivedSubscriptionData
 */
export interface SendhubWebhookReceivedSubscriptionData {
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionData
   */
  message?: string
  /**
   *
   * @type {SendhubWebhookReceivedSubscriptionDataContact}
   * @memberof SendhubWebhookReceivedSubscriptionData
   */
  contact?: SendhubWebhookReceivedSubscriptionDataContact
  /**
   *
   * @type {SendhubWebhookReceivedSubscriptionDataGroup}
   * @memberof SendhubWebhookReceivedSubscriptionData
   */
  group?: SendhubWebhookReceivedSubscriptionDataGroup
}
/**
 *
 * @export
 * @interface SendhubWebhookReceivedSubscriptionDataContact
 */
export interface SendhubWebhookReceivedSubscriptionDataContact {
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  smsGateway?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  user_id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  keyword?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  date_modified?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  deleted?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  number?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  screened?: boolean
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  is_owned?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  id_str?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  date_created?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  extra_info?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  id?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionDataContact
   */
  blocked?: boolean
}
/**
 *
 * @export
 * @interface SendhubWebhookReceivedSubscriptionDataGroup
 */
export interface SendhubWebhookReceivedSubscriptionDataGroup {
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  check_all?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  mediums?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  user_id?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  is_shared?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  date_modified?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  deleted?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  slug?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  text_to_subscribe?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  id_str?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  ttjResponse?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  date_created?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  permissions?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedSubscriptionDataGroup
   */
  name?: string
}
/**
 * A webhook that SendHub sends when someone unblocks your SendHub number by sending UNSTOP or START
 * @export
 * @interface SendhubWebhookReceivedUnblock
 */
export interface SendhubWebhookReceivedUnblock {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookReceivedUnblock
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblock
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblock
   */
  type?: TypeEnum
  /**
   *
   * @type {SendhubWebhookReceivedUnblockData}
   * @memberof SendhubWebhookReceivedUnblock
   */
  data?: SendhubWebhookReceivedUnblockData
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum {
  ReceivedUnblock = 'receivedUnblock',
}

/**
 *
 * @export
 * @interface SendhubWebhookReceivedUnblockData
 */
export interface SendhubWebhookReceivedUnblockData {
  /**
   * The unblocked number. Sent by newer SendHub versions, even when there is no contact.
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockData
   */
  phone_number?: string
  /**
   *
   * @type {SendhubWebhookReceivedUnblockDataContact}
   * @memberof SendhubWebhookReceivedUnblockData
   */
  contact?: SendhubWebhookReceivedUnblockDataContact | null
}
/**
 *
 * @export
 * @interface SendhubWebhookReceivedUnblockDataContact
 */
export interface SendhubWebhookReceivedUnblockDataContact {
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  smsGateway?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  user_id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  keyword?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  date_modified?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  deleted?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  number?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  screened?: boolean
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  is_owned?: boolean
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  id_str?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  date_created?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  extra_info?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  id?: string
  /**
   *
   * @type {boolean}
   * @memberof SendhubWebhookReceivedUnblockDataContact
   */
  blocked?: boolean
}
/**
 * A webhook that SendHub sends when someone unsubscribes from a group by sending UNSUBSCRIBE <GROUP-KEYWORD>
 * @export
 * @interface SendhubWebhookReceivedUnsubscription
 */
export interface SendhubWebhookReceivedUnsubscription {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookReceivedUnsubscription
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookReceivedUnsubscription
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookReceivedUnsubscription
   */
  type?: TypeEnum
  /**
   *
   * @type {SendhubWebhookReceivedSubscriptionConfirmedData}
   * @memberof SendhubWebhookReceivedUnsubscription
   */
  data?: SendhubWebhookReceivedSubscriptionConfirmedData
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum {
  ReceivedUnsubscription = 'receivedUnsubscription',
}

/**
 * A webhook that SendHub sends when your SendHub account sends an outbound message
 * @export
 * @interface SendhubWebhookSentMessage
 */
export interface SendhubWebhookSentMessage {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookSentMessage
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookSentMessage
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookSentMessage
   */
  type?: TypeEnum
  /**
   *
   * @type {SendhubWebhookSentMessageData}
   * @memberof SendhubWebhookSentMessage
   */
  data?: SendhubWebhookSentMessageData
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum {
  SentMessage = 'sentMessage',
}

/**
 *
 * @export
 * @interface SendhubWebhookSentMessageData
 */
export interface SendhubWebhookSentMessageData {
  /**
   *
   * @type {SendhubWebhookSentMessageDataMessage}
   * @memberof SendhubWebhookSentMessageData
   */
  message?: SendhubWebhookSentMessageDataMessage
}
/**
 *
 * @export
 * @interface SendhubWebhookSentMessageDataMessage
 */
export interface SendhubWebhookSentMessageDataMessage {
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookSentMessageDataMessage
   */
  direction?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookSentMessageDataMessage
   */
  user_id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookSentMessageDataMessage
   */
  text?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookSentMessageDataMessage
   */
  created_at?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookSentMessageDataMessage
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookSentMessageDataMessage
   */
  thread_id?: string
  /**
   *
   * @type {Array<string>}
   * @memberof SendhubWebhookSentMessageDataMessage
   */
  numbers?: Array<string>
  /**
   *
   * @type {Array<string>}
   * @memberof SendhubWebhookSentMessageDataMessage
   */
  groups?: Array<string>
}
/**
 * A webhook that SendHub sends when saving a new URL in the `Webhook URL` field in the My Settings page
 * @export
 * @interface SendhubWebhookTestWebHook
 */
export interface SendhubWebhookTestWebHook {
  /**
   * The webhook\'s timestamp (in seconds since the Unix Epoch)
   * @type {number}
   * @memberof SendhubWebhookTestWebHook
   */
  timestamp?: number
  /**
   * Unique identifier for this webhook. This is useful for de-duping re-tried webhooks
   * @type {string}
   * @memberof SendhubWebhookTestWebHook
   */
  requestId?: string
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookTestWebHook
   */
  type?: TypeEnum
  /**
   *
   * @type {SendhubWebhookTestWebHookData}
   * @memberof SendhubWebhookTestWebHook
   */
  data?: SendhubWebhookTestWebHookData
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum {
  TestWebHook = 'testWebHook',
}

/**
 *
 * @export
 * @interface SendhubWebhookTestWebHookData
 */
export interface SendhubWebhookTestWebHookData {
  /**
   *
   * @type {string}
   * @memberof SendhubWebhookTestWebHookData
   */
  message?: MessageEnum
}

/**
 * @export
 * @enum {string}
 */
export enum MessageEnum {
  TestMessage = 'Test Message',
}

/**
 *
 * @export
 * @enum {string}
 */
export enum SendhubWebhookType {
  TestWebHook = 'testWebHook',
  ReceivedBlock = 'receivedBlock',
  ReceivedUnblock = 'receivedUnblock',
  ReceivedMessage = 'receivedMessage',
  SentMessage = 'sentMessage',
  ReceivedSubscription = 'receivedSubscription',
  ReceivedSubscriptionConfirmed = 'receivedSubscriptionConfirmed',
  ReceivedUnsubscription = 'receivedUnsubscription',
}

/**
 *
 * @export
 * @interface ServiceAccount
 */
export interface ServiceAccount {
  /**
   *
   * @type {string}
   * @memberof ServiceAccount
   */
  id: string
  /**
   * SendHub User ID that this ServiceAccount belongs to.
   * @type {string}
   * @memberof ServiceAccount
   */
  userId: string
  /**
   * Nickname to help identify ServiceAccounts.
   * @type {string}
   * @memberof ServiceAccount
   */
  nickname: string
  /**
   * ID of the IntegrationGroup that this ServiceAccount relates to.
   * @type {string}
   * @memberof ServiceAccount
   */
  integrationGroupId: string
  /**
   *
   * @type {ServiceAccountCredentials}
   * @memberof ServiceAccount
   */
  credentials: ServiceAccountCredentials
}
/**
 *
 * @export
 * @interface ServiceAccountCreationPayload
 */
export interface ServiceAccountCreationPayload {
  /**
   * Nickname to help identify ServiceAccounts.
   * @type {string}
   * @memberof ServiceAccountCreationPayload
   */
  nickname: string
  /**
   * ID of the IntegrationGroup that this ServiceAccount relates to.
   * @type {string}
   * @memberof ServiceAccountCreationPayload
   */
  integrationGroupId: string
  /**
   *
   * @type {ServiceAccountCredentials}
   * @memberof ServiceAccountCreationPayload
   */
  credentials: ServiceAccountCredentials
}
/**
 * @type ServiceAccountCredentials
 * @export
 */
export type ServiceAccountCredentials =
  | ServiceAccountCredentialsFollowUpBoss
  | ServiceAccountCredentialsZapier

/**
 * Required credentials for a Follow Up Boss account
 * @export
 * @interface ServiceAccountCredentialsFollowUpBoss
 */
export interface ServiceAccountCredentialsFollowUpBoss {
  /**
   * Follow Up Boss API Key.
   * @type {string}
   * @memberof ServiceAccountCredentialsFollowUpBoss
   */
  apiKey: string
}
/**
 * Required credentials for a JazzHR account
 * @export
 * @interface ServiceAccountCredentialsJazzHR
 */
export interface ServiceAccountCredentialsJazzHR {
  /**
   * JazzHR API Key.
   * @type {string}
   * @memberof ServiceAccountCredentialsJazzHR
   */
  apiKey: string
}
/**
 * Required credentials for a Zapier account
 * @export
 * @interface ServiceAccountCredentialsZapier
 */
export interface ServiceAccountCredentialsZapier {
  /**
   * Zapier end-user\'s accessToken granted by oauth.
   * @type {string}
   * @memberof ServiceAccountCredentialsZapier
   */
  accessToken: string
  /**
   *
   * @type {ZapierProfile}
   * @memberof ServiceAccountCredentialsZapier
   */
  profile: ZapierProfile
}
/**
 * Result of deleting a ServiceAccount
 * @export
 * @interface ServiceAccountDeletionResult
 */
export interface ServiceAccountDeletionResult {
  /**
   * IntegrationConfigs that were turned off because they used this account
   * @type {Array<string>}
   * @memberof ServiceAccountDeletionResult
   */
  disabledIntegrationConfigIds: Array<string>
  /**
   * User-facing notes about cleanup that couldn\'t be completed (e.g. webhooks that couldn\'t be removed because the API key was already revoked)
   * @type {Array<string>}
   * @memberof ServiceAccountDeletionResult
   */
  warnings: Array<string>
}
/**
 *
 * @export
 * @interface TokenPairResponse
 */
export interface TokenPairResponse {
  /**
   *
   * @type {string}
   * @memberof TokenPairResponse
   */
  authToken: string
  /**
   *
   * @type {string}
   * @memberof TokenPairResponse
   */
  refreshToken: string
}
/**
 * @type WebhookBody
 * @export
 */
export type WebhookBody = FollowUpBossWebhookBody | SendhubWebhook

/**
 *
 * @export
 * @interface ZapierApp
 */
export interface ZapierApp {
  /**
   *
   * @type {Array<ZapierAppCategory>}
   * @memberof ZapierApp
   */
  categories: Array<ZapierAppCategory>
  /**
   *
   * @type {string}
   * @memberof ZapierApp
   */
  description: string
  /**
   *
   * @type {string}
   * @memberof ZapierApp
   */
  image: string
  /**
   *
   * @type {ZapierImages}
   * @memberof ZapierApp
   */
  images: ZapierImages
  /**
   *
   * @type {ZapierAppLinks}
   * @memberof ZapierApp
   */
  links: ZapierAppLinks
  /**
   *
   * @type {string}
   * @memberof ZapierApp
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof ZapierApp
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof ZapierApp
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof ZapierApp
   */
  uuid: string
}
/**
 *
 * @export
 * @interface ZapierAppCategory
 */
export interface ZapierAppCategory {
  /**
   *
   * @type {string}
   * @memberof ZapierAppCategory
   */
  slug: string
}
/**
 *
 * @export
 * @interface ZapierAppLinks
 */
export interface ZapierAppLinks {
  /**
   *
   * @type {string}
   * @memberof ZapierAppLinks
   */
  mutualzap_templates: string
}
/**
 *
 * @export
 * @interface ZapierAppsResponse
 */
export interface ZapierAppsResponse {
  /**
   *
   * @type {number}
   * @memberof ZapierAppsResponse
   */
  total: number
  /**
   *
   * @type {number}
   * @memberof ZapierAppsResponse
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof ZapierAppsResponse
   */
  pages: number
  /**
   *
   * @type {number}
   * @memberof ZapierAppsResponse
   */
  per_page: number
  /**
   *
   * @type {Array<ZapierApp>}
   * @memberof ZapierAppsResponse
   */
  objects: Array<ZapierApp>
  /**
   *
   * @type {string}
   * @memberof ZapierAppsResponse
   */
  prev_url: string | null
  /**
   *
   * @type {string}
   * @memberof ZapierAppsResponse
   */
  next_url: string | null
}
/**
 *
 * @export
 * @interface ZapierImages
 */
export interface ZapierImages {
  /**
   *
   * @type {string}
   * @memberof ZapierImages
   */
  url_16x16: string
  /**
   *
   * @type {string}
   * @memberof ZapierImages
   */
  url_32x32: string
  /**
   *
   * @type {string}
   * @memberof ZapierImages
   */
  url_64x64: string
  /**
   *
   * @type {string}
   * @memberof ZapierImages
   */
  url_128x128: string
}
/**
 *
 * @export
 * @interface ZapierProfile
 */
export interface ZapierProfile {
  /**
   *
   * @type {number}
   * @memberof ZapierProfile
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ZapierProfile
   */
  first_name: string
  /**
   *
   * @type {string}
   * @memberof ZapierProfile
   */
  last_name: string
  /**
   *
   * @type {string}
   * @memberof ZapierProfile
   */
  email: string
  /**
   *
   * @type {boolean}
   * @memberof ZapierProfile
   */
  email_confirmed: boolean
  /**
   *
   * @type {string}
   * @memberof ZapierProfile
   */
  timezone: string | null
  /**
   *
   * @type {string}
   * @memberof ZapierProfile
   */
  full_name: string
}
/**
 *
 * @export
 * @interface ZapierStep
 */
export interface ZapierStep {
  /**
   *
   * @type {number}
   * @memberof ZapierStep
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  uuid: string
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  description: string
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  image: string
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  hex_color: string
  /**
   *
   * @type {ZapierImages}
   * @memberof ZapierStep
   */
  images: ZapierImages
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  api: string
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof ZapierStep
   */
  label: string
}
/**
 *
 * @export
 * @interface ZapierTemplate
 */
export interface ZapierTemplate {
  /**
   *
   * @type {number}
   * @memberof ZapierTemplate
   */
  id: number
  /**
   *
   * @type {Array<ZapierStep>}
   * @memberof ZapierTemplate
   */
  steps: Array<ZapierStep>
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  status: string
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  description_plain: string
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  description_raw: string
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  description: string
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  create_url: string
  /**
   *
   * @type {string}
   * @memberof ZapierTemplate
   */
  type: string
}
/**
 *
 * @export
 * @interface ZapierZap
 */
export interface ZapierZap {
  /**
   *
   * @type {number}
   * @memberof ZapierZap
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ZapierZap
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof ZapierZap
   */
  state: string
  /**
   *
   * @type {Array<ZapierZapStep>}
   * @memberof ZapierZap
   */
  steps: Array<ZapierZapStep>
  /**
   *
   * @type {string}
   * @memberof ZapierZap
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof ZapierZap
   */
  modified_at: string
}
/**
 *
 * @export
 * @interface ZapierZapNestedApp
 */
export interface ZapierZapNestedApp {
  /**
   *
   * @type {Array<ZapierAppCategory>}
   * @memberof ZapierZapNestedApp
   */
  categories: Array<ZapierAppCategory>
  /**
   *
   * @type {string}
   * @memberof ZapierZapNestedApp
   */
  description: string
  /**
   *
   * @type {string}
   * @memberof ZapierZapNestedApp
   */
  image: string
  /**
   *
   * @type {ZapierImages}
   * @memberof ZapierZapNestedApp
   */
  images: ZapierImages
  /**
   *
   * @type {ZapierAppLinks}
   * @memberof ZapierZapNestedApp
   */
  links: ZapierAppLinks
  /**
   *
   * @type {string}
   * @memberof ZapierZapNestedApp
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof ZapierZapNestedApp
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof ZapierZapNestedApp
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof ZapierZapNestedApp
   */
  uuid: string
  /**
   *
   * @type {string}
   * @memberof ZapierZapNestedApp
   */
  api: string
  /**
   *
   * @type {string}
   * @memberof ZapierZapNestedApp
   */
  hex_color: string
  /**
   *
   * @type {number}
   * @memberof ZapierZapNestedApp
   */
  id: number
}
/**
 *
 * @export
 * @interface ZapierZapStep
 */
export interface ZapierZapStep {
  /**
   *
   * @type {ZapierZapNestedApp}
   * @memberof ZapierZapStep
   */
  app: ZapierZapNestedApp
  /**
   * One of \"read\", \"search\", or \"write\"
   * @type {string}
   * @memberof ZapierZapStep
   */
  type_of: string
}
/**
 *
 * @export
 * @interface ZapierZapsResponse
 */
export interface ZapierZapsResponse {
  /**
   *
   * @type {string}
   * @memberof ZapierZapsResponse
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof ZapierZapsResponse
   */
  previous: string | null
  /**
   *
   * @type {number}
   * @memberof ZapierZapsResponse
   */
  count: number
  /**
   *
   * @type {Array<ZapierZap>}
   * @memberof ZapierZapsResponse
   */
  objects: Array<ZapierZap>
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Creates an IntegrationConfig
     * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createIntegrationConfig: async (
      integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/integrationConfigs`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof integrationConfigCreationPayload !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            integrationConfigCreationPayload !== undefined
              ? integrationConfigCreationPayload
              : {}
          )
        : integrationConfigCreationPayload || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Creates an ServiceAccount
     * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createServiceAccount: async (
      serviceAccountCreationPayload?: ServiceAccountCreationPayload,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/serviceAccounts`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof serviceAccountCreationPayload !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            serviceAccountCreationPayload !== undefined
              ? serviceAccountCreationPayload
              : {}
          )
        : serviceAccountCreationPayload || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Delete a ServiceAccount. Turns off and unlinks every IntegrationConfig using it, removes its webhooks in the third-party service, and wipes the stored credentials.
     * @summary Delete Service Account
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteServiceAccount: async (
      serviceAccountId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceAccountId' is not null or undefined
      if (serviceAccountId === null || serviceAccountId === undefined) {
        throw new RequiredError(
          'serviceAccountId',
          'Required parameter serviceAccountId was null or undefined when calling deleteServiceAccount.'
        )
      }
      const localVarPath = `/serviceAccounts/{serviceAccountId}`.replace(
        `{${'serviceAccountId'}}`,
        encodeURIComponent(String(serviceAccountId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get Integration
     * @summary Your GET endpoint
     * @param {string} integrationId ID of the integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegration: async (
      integrationId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'integrationId' is not null or undefined
      if (integrationId === null || integrationId === undefined) {
        throw new RequiredError(
          'integrationId',
          'Required parameter integrationId was null or undefined when calling getIntegration.'
        )
      }
      const localVarPath = `/integrations/{integrationId}`.replace(
        `{${'integrationId'}}`,
        encodeURIComponent(String(integrationId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get an IntegrationConfig
     * @summary Your GET endpoint
     * @param {string} integrationConfigId ID of the IntegrationConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegrationConfig: async (
      integrationConfigId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'integrationConfigId' is not null or undefined
      if (integrationConfigId === null || integrationConfigId === undefined) {
        throw new RequiredError(
          'integrationConfigId',
          'Required parameter integrationConfigId was null or undefined when calling getIntegrationConfig.'
        )
      }
      const localVarPath = `/integrationConfigs/{integrationConfigId}`.replace(
        `{${'integrationConfigId'}}`,
        encodeURIComponent(String(integrationConfigId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get IntegrationGroup
     * @summary Get Integration Group
     * @param {string} integrationGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegrationGroup: async (
      integrationGroupId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'integrationGroupId' is not null or undefined
      if (integrationGroupId === null || integrationGroupId === undefined) {
        throw new RequiredError(
          'integrationGroupId',
          'Required parameter integrationGroupId was null or undefined when calling getIntegrationGroup.'
        )
      }
      const localVarPath = `/integrationGroups/{integrationGroupId}`.replace(
        `{${'integrationGroupId'}}`,
        encodeURIComponent(String(integrationGroupId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a ServiceAccount
     * @summary Get Service Account by ID
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceAccount: async (
      serviceAccountId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceAccountId' is not null or undefined
      if (serviceAccountId === null || serviceAccountId === undefined) {
        throw new RequiredError(
          'serviceAccountId',
          'Required parameter serviceAccountId was null or undefined when calling getServiceAccount.'
        )
      }
      const localVarPath = `/serviceAccounts/{serviceAccountId}`.replace(
        `{${'serviceAccountId'}}`,
        encodeURIComponent(String(serviceAccountId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get Zapier Profile
     * @summary Get Zapier Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getZapierProfile: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/zapier/profiles/me`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Zapier_Access_Token required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List IntegrationConfigs
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listIntegrationConfigs: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/integrationConfigs`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List IntegrationGroups
     * @summary List Integration Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listIntegrationGroups: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/integrationGroups`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Lists Integrations
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listIntegrations: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/integrations`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List ServiceAccounts
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listServiceAccounts: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/serviceAccounts`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List Zapier Apps
     * @summary List Zapier Apps
     * @param {number} [perPage] (defaults to 100, max of 100) Limit the number of apps returned.
     * @param {number} [page] (defaults to 1) The page number. Page number 1 refers to the first page in the result.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listZapierApps: async (
      perPage?: number,
      page?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/zapier/apps`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      if (perPage !== undefined) {
        localVarQueryParameter['per_page'] = perPage
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List Zapier Zap Templates
     * @summary List Zap templates
     * @param {string} [templates] A comma separated list of specific Zap templates.
     * @param {string} [apps] A comma separated list of Zapier Apps to match Zap templates against. *Note: SendHub will always be one of the apps.*
     * @param {number} [limit] (defaults to 5, max of 100) Limit the number of Zap templates returned.
     * @param {number} [offset] (defaults to 0) The number of Zap templates to skip before beginning to return the Zap templates. The default value is 0, which is the offset of the first item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listZapierTemplates: async (
      templates?: string,
      apps?: string,
      limit?: number,
      offset?: number,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/zapier/zap-templates`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      if (templates !== undefined) {
        localVarQueryParameter['templates'] = templates
      }

      if (apps !== undefined) {
        localVarQueryParameter['apps'] = apps
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List Zapier Zaps
     * @summary List Zapier Zaps
     * @param {number} [limit] (defaults to 5, max of 100) Limits the number of returned items
     * @param {number} [offset] (defaults to 0) the number of Zaps to skip before beginning to return the Zaps. The default value of 0, which is the offset of the first item.
     * @param {{ [key: string]: string; }} [params] Return Zaps that have a specific key/value set in the params (settings) of the Zap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listZapierZaps: async (
      limit?: number,
      offset?: number,
      params?: { [key: string]: string },
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/zapier/zaps`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Zapier_Access_Token required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (params !== undefined) {
        localVarQueryParameter['params__*'] = params
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sign in via your SendHub username and password
     * @summary Sign in via your SendHub username and password
     * @param {LoginPayload1} [loginPayload1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login: async (
      loginPayload1?: LoginPayload1,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/login`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof loginPayload1 !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(loginPayload1 !== undefined ? loginPayload1 : {})
        : loginPayload1 || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sign out of SendHub Integrations (and optionally, app.SendHub.com)
     * @summary Sign out of SendHub Integrations (and optionally, app.SendHub.com)
     * @param {LogoutPayload1} [logoutPayload1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout: async (
      logoutPayload1?: LogoutPayload1,
      options: any = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/logout`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof logoutPayload1 !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(logoutPayload1 !== undefined ? logoutPayload1 : {})
        : logoutPayload1 || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Handles 3rd-party webhooks
     * @param {string} registeredWebhookId ID of the RegisteredWebhook
     * @param {WebhookBody} [webhookBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhook: async (
      registeredWebhookId: string,
      webhookBody?: WebhookBody,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'registeredWebhookId' is not null or undefined
      if (registeredWebhookId === null || registeredWebhookId === undefined) {
        throw new RequiredError(
          'registeredWebhookId',
          'Required parameter registeredWebhookId was null or undefined when calling postWebhook.'
        )
      }
      const localVarPath = `/webhooks/{registeredWebhookId}`.replace(
        `{${'registeredWebhookId'}}`,
        encodeURIComponent(String(registeredWebhookId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof webhookBody !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(webhookBody !== undefined ? webhookBody : {})
        : webhookBody || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Refresh your Access Token
     * @summary Refresh your Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/refresh`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Refresh_Header required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('X-Refresh-Token')
            : await configuration.apiKey
        localVarHeaderParameter['X-Refresh-Token'] = localVarApiKeyValue
      }

      // authentication JWT_Refresh_Token required

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Submit a New Integration Request with the required fields
     * @summary Submit a New Integration Request
     * @param {NewIntegrationFormPayload} newIntegrationFormPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestIntegration: async (
      newIntegrationFormPayload: NewIntegrationFormPayload,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'newIntegrationFormPayload' is not null or undefined
      if (
        newIntegrationFormPayload === null ||
        newIntegrationFormPayload === undefined
      ) {
        throw new RequiredError(
          'newIntegrationFormPayload',
          'Required parameter newIntegrationFormPayload was null or undefined when calling requestIntegration.'
        )
      }
      const localVarPath = `/requestIntegration`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof newIntegrationFormPayload !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            newIntegrationFormPayload !== undefined
              ? newIntegrationFormPayload
              : {}
          )
        : newIntegrationFormPayload || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sign in via your existing SendHub session!
     * @summary Sign in via your existing SendHub session!
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sso: async (options: any = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/sso`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication SendHub_Session required

      // authentication SendHub_Session04 required

      // authentication SendHub_Session05 required

      // authentication SendHub_SessionDev required

      // authentication SendHub_SessionDev01 required

      // authentication SendHub_SessionProduction required

      // authentication SendHub_SessionStaging required

      // authentication SendHub_Session_Header required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? await configuration.apiKey('X-SH-Session-Key')
            : await configuration.apiKey
        localVarHeaderParameter['X-SH-Session-Key'] = localVarApiKeyValue
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Update an IntegrationConfig
     * @param {string} integrationConfigId ID of the IntegrationConfig
     * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntegrationConfig: async (
      integrationConfigId: string,
      integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'integrationConfigId' is not null or undefined
      if (integrationConfigId === null || integrationConfigId === undefined) {
        throw new RequiredError(
          'integrationConfigId',
          'Required parameter integrationConfigId was null or undefined when calling updateIntegrationConfig.'
        )
      }
      const localVarPath = `/integrationConfigs/{integrationConfigId}`.replace(
        `{${'integrationConfigId'}}`,
        encodeURIComponent(String(integrationConfigId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof integrationConfigCreationPayload !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            integrationConfigCreationPayload !== undefined
              ? integrationConfigCreationPayload
              : {}
          )
        : integrationConfigCreationPayload || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Update an ServiceAccount
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServiceAccount: async (
      serviceAccountId: string,
      serviceAccountCreationPayload?: ServiceAccountCreationPayload,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'serviceAccountId' is not null or undefined
      if (serviceAccountId === null || serviceAccountId === undefined) {
        throw new RequiredError(
          'serviceAccountId',
          'Required parameter serviceAccountId was null or undefined when calling updateServiceAccount.'
        )
      }
      const localVarPath = `/serviceAccounts/{serviceAccountId}`.replace(
        `{${'serviceAccountId'}}`,
        encodeURIComponent(String(serviceAccountId))
      )
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication JWT_Bearer required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? configuration.accessToken()
            : configuration.accessToken
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken
      }

      // authentication JWT_Token required

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      const needsSerialization =
        typeof serviceAccountCreationPayload !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(
            serviceAccountCreationPayload !== undefined
              ? serviceAccountCreationPayload
              : {}
          )
        : serviceAccountCreationPayload || ''

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Creates an IntegrationConfig
     * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createIntegrationConfig(
      integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IntegrationConfig>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).createIntegrationConfig(integrationConfigCreationPayload, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Creates an ServiceAccount
     * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createServiceAccount(
      serviceAccountCreationPayload?: ServiceAccountCreationPayload,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceAccount>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).createServiceAccount(serviceAccountCreationPayload, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Delete a ServiceAccount. Turns off and unlinks every IntegrationConfig using it, removes its webhooks in the third-party service, and wipes the stored credentials.
     * @summary Delete Service Account
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteServiceAccount(
      serviceAccountId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ServiceAccountDeletionResult>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).deleteServiceAccount(serviceAccountId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get Integration
     * @summary Your GET endpoint
     * @param {string} integrationId ID of the integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIntegration(
      integrationId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Integration1>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).getIntegration(integrationId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get an IntegrationConfig
     * @summary Your GET endpoint
     * @param {string} integrationConfigId ID of the IntegrationConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIntegrationConfig(
      integrationConfigId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IntegrationConfig>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).getIntegrationConfig(integrationConfigId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get IntegrationGroup
     * @summary Get Integration Group
     * @param {string} integrationGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIntegrationGroup(
      integrationGroupId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IntegrationGroup1>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).getIntegrationGroup(integrationGroupId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get a ServiceAccount
     * @summary Get Service Account by ID
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getServiceAccount(
      serviceAccountId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceAccount>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).getServiceAccount(serviceAccountId, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Get Zapier Profile
     * @summary Get Zapier Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getZapierProfile(
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZapierProfile>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).getZapierProfile(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List IntegrationConfigs
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listIntegrationConfigs(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<IntegrationConfig>>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).listIntegrationConfigs(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List IntegrationGroups
     * @summary List Integration Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listIntegrationGroups(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<IntegrationGroup>>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).listIntegrationGroups(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Lists Integrations
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listIntegrations(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Integration1>>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).listIntegrations(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List ServiceAccounts
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listServiceAccounts(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ServiceAccount>>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).listServiceAccounts(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List Zapier Apps
     * @summary List Zapier Apps
     * @param {number} [perPage] (defaults to 100, max of 100) Limit the number of apps returned.
     * @param {number} [page] (defaults to 1) The page number. Page number 1 refers to the first page in the result.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listZapierApps(
      perPage?: number,
      page?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ZapierAppsResponse>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).listZapierApps(perPage, page, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List Zapier Zap Templates
     * @summary List Zap templates
     * @param {string} [templates] A comma separated list of specific Zap templates.
     * @param {string} [apps] A comma separated list of Zapier Apps to match Zap templates against. *Note: SendHub will always be one of the apps.*
     * @param {number} [limit] (defaults to 5, max of 100) Limit the number of Zap templates returned.
     * @param {number} [offset] (defaults to 0) The number of Zap templates to skip before beginning to return the Zap templates. The default value is 0, which is the offset of the first item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listZapierTemplates(
      templates?: string,
      apps?: string,
      limit?: number,
      offset?: number,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<ZapierTemplate>>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).listZapierTemplates(templates, apps, limit, offset, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * List Zapier Zaps
     * @summary List Zapier Zaps
     * @param {number} [limit] (defaults to 5, max of 100) Limits the number of returned items
     * @param {number} [offset] (defaults to 0) the number of Zaps to skip before beginning to return the Zaps. The default value of 0, which is the offset of the first item.
     * @param {{ [key: string]: string; }} [params] Return Zaps that have a specific key/value set in the params (settings) of the Zap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listZapierZaps(
      limit?: number,
      offset?: number,
      params?: { [key: string]: string },
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ZapierZapsResponse>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).listZapierZaps(limit, offset, params, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Sign in via your SendHub username and password
     * @summary Sign in via your SendHub username and password
     * @param {LoginPayload1} [loginPayload1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login(
      loginPayload1?: LoginPayload1,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TokenPairResponse>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).login(loginPayload1, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Sign out of SendHub Integrations (and optionally, app.SendHub.com)
     * @summary Sign out of SendHub Integrations (and optionally, app.SendHub.com)
     * @param {LogoutPayload1} [logoutPayload1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logout(
      logoutPayload1?: LogoutPayload1,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).logout(logoutPayload1, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Handles 3rd-party webhooks
     * @param {string} registeredWebhookId ID of the RegisteredWebhook
     * @param {WebhookBody} [webhookBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhook(
      registeredWebhookId: string,
      webhookBody?: WebhookBody,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).postWebhook(registeredWebhookId, webhookBody, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Refresh your Access Token
     * @summary Refresh your Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refreshToken(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TokenPairResponse>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).refreshToken(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Submit a New Integration Request with the required fields
     * @summary Submit a New Integration Request
     * @param {NewIntegrationFormPayload} newIntegrationFormPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async requestIntegration(
      newIntegrationFormPayload: NewIntegrationFormPayload,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<NewIntegrationFormResponse>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).requestIntegration(newIntegrationFormPayload, options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Sign in via your existing SendHub session!
     * @summary Sign in via your existing SendHub session!
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sso(
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TokenPairResponse>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).sso(options)
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Update an IntegrationConfig
     * @param {string} integrationConfigId ID of the IntegrationConfig
     * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateIntegrationConfig(
      integrationConfigId: string,
      integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IntegrationConfig>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).updateIntegrationConfig(
        integrationConfigId,
        integrationConfigCreationPayload,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
    /**
     * Update an ServiceAccount
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateServiceAccount(
      serviceAccountId: string,
      serviceAccountCreationPayload?: ServiceAccountCreationPayload,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceAccount>
    > {
      const localVarAxiosArgs = await DefaultApiAxiosParamCreator(
        configuration
      ).updateServiceAccount(
        serviceAccountId,
        serviceAccountCreationPayload,
        options
      )
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     * Creates an IntegrationConfig
     * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createIntegrationConfig(
      integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
      options?: any
    ): AxiosPromise<IntegrationConfig> {
      return DefaultApiFp(configuration)
        .createIntegrationConfig(integrationConfigCreationPayload, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Creates an ServiceAccount
     * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createServiceAccount(
      serviceAccountCreationPayload?: ServiceAccountCreationPayload,
      options?: any
    ): AxiosPromise<ServiceAccount> {
      return DefaultApiFp(configuration)
        .createServiceAccount(serviceAccountCreationPayload, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Delete a ServiceAccount. Turns off and unlinks every IntegrationConfig using it, removes its webhooks in the third-party service, and wipes the stored credentials.
     * @summary Delete Service Account
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteServiceAccount(
      serviceAccountId: string,
      options?: any
    ): AxiosPromise<ServiceAccountDeletionResult> {
      return DefaultApiFp(configuration)
        .deleteServiceAccount(serviceAccountId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get Integration
     * @summary Your GET endpoint
     * @param {string} integrationId ID of the integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegration(
      integrationId: string,
      options?: any
    ): AxiosPromise<Integration1> {
      return DefaultApiFp(configuration)
        .getIntegration(integrationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get an IntegrationConfig
     * @summary Your GET endpoint
     * @param {string} integrationConfigId ID of the IntegrationConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegrationConfig(
      integrationConfigId: string,
      options?: any
    ): AxiosPromise<IntegrationConfig> {
      return DefaultApiFp(configuration)
        .getIntegrationConfig(integrationConfigId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get IntegrationGroup
     * @summary Get Integration Group
     * @param {string} integrationGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegrationGroup(
      integrationGroupId: string,
      options?: any
    ): AxiosPromise<IntegrationGroup1> {
      return DefaultApiFp(configuration)
        .getIntegrationGroup(integrationGroupId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a ServiceAccount
     * @summary Get Service Account by ID
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceAccount(
      serviceAccountId: string,
      options?: any
    ): AxiosPromise<ServiceAccount> {
      return DefaultApiFp(configuration)
        .getServiceAccount(serviceAccountId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get Zapier Profile
     * @summary Get Zapier Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getZapierProfile(options?: any): AxiosPromise<ZapierProfile> {
      return DefaultApiFp(configuration)
        .getZapierProfile(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List IntegrationConfigs
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listIntegrationConfigs(
      options?: any
    ): AxiosPromise<Array<IntegrationConfig>> {
      return DefaultApiFp(configuration)
        .listIntegrationConfigs(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List IntegrationGroups
     * @summary List Integration Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listIntegrationGroups(
      options?: any
    ): AxiosPromise<Array<IntegrationGroup>> {
      return DefaultApiFp(configuration)
        .listIntegrationGroups(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Lists Integrations
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listIntegrations(options?: any): AxiosPromise<Array<Integration1>> {
      return DefaultApiFp(configuration)
        .listIntegrations(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List ServiceAccounts
     * @summary Your GET endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listServiceAccounts(options?: any): AxiosPromise<Array<ServiceAccount>> {
      return DefaultApiFp(configuration)
        .listServiceAccounts(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List Zapier Apps
     * @summary List Zapier Apps
     * @param {number} [perPage] (defaults to 100, max of 100) Limit the number of apps returned.
     * @param {number} [page] (defaults to 1) The page number. Page number 1 refers to the first page in the result.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listZapierApps(
      perPage?: number,
      page?: number,
      options?: any
    ): AxiosPromise<ZapierAppsResponse> {
      return DefaultApiFp(configuration)
        .listZapierApps(perPage, page, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List Zapier Zap Templates
     * @summary List Zap templates
     * @param {string} [templates] A comma separated list of specific Zap templates.
     * @param {string} [apps] A comma separated list of Zapier Apps to match Zap templates against. *Note: SendHub will always be one of the apps.*
     * @param {number} [limit] (defaults to 5, max of 100) Limit the number of Zap templates returned.
     * @param {number} [offset] (defaults to 0) The number of Zap templates to skip before beginning to return the Zap templates. The default value is 0, which is the offset of the first item.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listZapierTemplates(
      templates?: string,
      apps?: string,
      limit?: number,
      offset?: number,
      options?: any
    ): AxiosPromise<Array<ZapierTemplate>> {
      return DefaultApiFp(configuration)
        .listZapierTemplates(templates, apps, limit, offset, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List Zapier Zaps
     * @summary List Zapier Zaps
     * @param {number} [limit] (defaults to 5, max of 100) Limits the number of returned items
     * @param {number} [offset] (defaults to 0) the number of Zaps to skip before beginning to return the Zaps. The default value of 0, which is the offset of the first item.
     * @param {{ [key: string]: string; }} [params] Return Zaps that have a specific key/value set in the params (settings) of the Zap.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listZapierZaps(
      limit?: number,
      offset?: number,
      params?: { [key: string]: string },
      options?: any
    ): AxiosPromise<ZapierZapsResponse> {
      return DefaultApiFp(configuration)
        .listZapierZaps(limit, offset, params, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Sign in via your SendHub username and password
     * @summary Sign in via your SendHub username and password
     * @param {LoginPayload1} [loginPayload1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(
      loginPayload1?: LoginPayload1,
      options?: any
    ): AxiosPromise<TokenPairResponse> {
      return DefaultApiFp(configuration)
        .login(loginPayload1, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Sign out of SendHub Integrations (and optionally, app.SendHub.com)
     * @summary Sign out of SendHub Integrations (and optionally, app.SendHub.com)
     * @param {LogoutPayload1} [logoutPayload1]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(logoutPayload1?: LogoutPayload1, options?: any): AxiosPromise<void> {
      return DefaultApiFp(configuration)
        .logout(logoutPayload1, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Handles 3rd-party webhooks
     * @param {string} registeredWebhookId ID of the RegisteredWebhook
     * @param {WebhookBody} [webhookBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhook(
      registeredWebhookId: string,
      webhookBody?: WebhookBody,
      options?: any
    ): AxiosPromise<void> {
      return DefaultApiFp(configuration)
        .postWebhook(registeredWebhookId, webhookBody, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Refresh your Access Token
     * @summary Refresh your Access Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(options?: any): AxiosPromise<TokenPairResponse> {
      return DefaultApiFp(configuration)
        .refreshToken(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Submit a New Integration Request with the required fields
     * @summary Submit a New Integration Request
     * @param {NewIntegrationFormPayload} newIntegrationFormPayload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestIntegration(
      newIntegrationFormPayload: NewIntegrationFormPayload,
      options?: any
    ): AxiosPromise<NewIntegrationFormResponse> {
      return DefaultApiFp(configuration)
        .requestIntegration(newIntegrationFormPayload, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Sign in via your existing SendHub session!
     * @summary Sign in via your existing SendHub session!
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sso(options?: any): AxiosPromise<TokenPairResponse> {
      return DefaultApiFp(configuration)
        .sso(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an IntegrationConfig
     * @param {string} integrationConfigId ID of the IntegrationConfig
     * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntegrationConfig(
      integrationConfigId: string,
      integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
      options?: any
    ): AxiosPromise<IntegrationConfig> {
      return DefaultApiFp(configuration)
        .updateIntegrationConfig(
          integrationConfigId,
          integrationConfigCreationPayload,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Update an ServiceAccount
     * @param {string} serviceAccountId ID of the ServiceAccount
     * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServiceAccount(
      serviceAccountId: string,
      serviceAccountCreationPayload?: ServiceAccountCreationPayload,
      options?: any
    ): AxiosPromise<ServiceAccount> {
      return DefaultApiFp(configuration)
        .updateServiceAccount(
          serviceAccountId,
          serviceAccountCreationPayload,
          options
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * DefaultApi - interface
 * @export
 * @interface DefaultApi
 */
export interface DefaultApiInterface {
  /**
   * Creates an IntegrationConfig
   * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  createIntegrationConfig(
    integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
    options?: any
  ): AxiosPromise<IntegrationConfig>

  /**
   * Creates an ServiceAccount
   * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  createServiceAccount(
    serviceAccountCreationPayload?: ServiceAccountCreationPayload,
    options?: any
  ): AxiosPromise<ServiceAccount>

  /**
   * Delete a ServiceAccount. Turns off and unlinks every IntegrationConfig using it, removes its webhooks in the third-party service, and wipes the stored credentials.
   * @summary Delete Service Account
   * @param {string} serviceAccountId ID of the ServiceAccount
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  deleteServiceAccount(
    serviceAccountId: string,
    options?: any
  ): AxiosPromise<ServiceAccountDeletionResult>

  /**
   * Get Integration
   * @summary Your GET endpoint
   * @param {string} integrationId ID of the integration
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  getIntegration(
    integrationId: string,
    options?: any
  ): AxiosPromise<Integration1>

  /**
   * Get an IntegrationConfig
   * @summary Your GET endpoint
   * @param {string} integrationConfigId ID of the IntegrationConfig
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  getIntegrationConfig(
    integrationConfigId: string,
    options?: any
  ): AxiosPromise<IntegrationConfig>

  /**
   * Get IntegrationGroup
   * @summary Get Integration Group
   * @param {string} integrationGroupId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  getIntegrationGroup(
    integrationGroupId: string,
    options?: any
  ): AxiosPromise<IntegrationGroup1>

  /**
   * Get a ServiceAccount
   * @summary Get Service Account by ID
   * @param {string} serviceAccountId ID of the ServiceAccount
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  getServiceAccount(
    serviceAccountId: string,
    options?: any
  ): AxiosPromise<ServiceAccount>

  /**
   * Get Zapier Profile
   * @summary Get Zapier Profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  getZapierProfile(options?: any): AxiosPromise<ZapierProfile>

  /**
   * List IntegrationConfigs
   * @summary Your GET endpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  listIntegrationConfigs(options?: any): AxiosPromise<Array<IntegrationConfig>>

  /**
   * List IntegrationGroups
   * @summary List Integration Groups
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  listIntegrationGroups(options?: any): AxiosPromise<Array<IntegrationGroup>>

  /**
   * Lists Integrations
   * @summary Your GET endpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  listIntegrations(options?: any): AxiosPromise<Array<Integration1>>

  /**
   * List ServiceAccounts
   * @summary Your GET endpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  listServiceAccounts(options?: any): AxiosPromise<Array<ServiceAccount>>

  /**
   * List Zapier Apps
   * @summary List Zapier Apps
   * @param {number} [perPage] (defaults to 100, max of 100) Limit the number of apps returned.
   * @param {number} [page] (defaults to 1) The page number. Page number 1 refers to the first page in the result.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  listZapierApps(
    perPage?: number,
    page?: number,
    options?: any
  ): AxiosPromise<ZapierAppsResponse>

  /**
   * List Zapier Zap Templates
   * @summary List Zap templates
   * @param {string} [templates] A comma separated list of specific Zap templates.
   * @param {string} [apps] A comma separated list of Zapier Apps to match Zap templates against. *Note: SendHub will always be one of the apps.*
   * @param {number} [limit] (defaults to 5, max of 100) Limit the number of Zap templates returned.
   * @param {number} [offset] (defaults to 0) The number of Zap templates to skip before beginning to return the Zap templates. The default value is 0, which is the offset of the first item.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  listZapierTemplates(
    templates?: string,
    apps?: string,
    limit?: number,
    offset?: number,
    options?: any
  ): AxiosPromise<Array<ZapierTemplate>>

  /**
   * List Zapier Zaps
   * @summary List Zapier Zaps
   * @param {number} [limit] (defaults to 5, max of 100) Limits the number of returned items
   * @param {number} [offset] (defaults to 0) the number of Zaps to skip before beginning to return the Zaps. The default value of 0, which is the offset of the first item.
   * @param {{ [key: string]: string; }} [params] Return Zaps that have a specific key/value set in the params (settings) of the Zap.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  listZapierZaps(
    limit?: number,
    offset?: number,
    params?: { [key: string]: string },
    options?: any
  ): AxiosPromise<ZapierZapsResponse>

  /**
   * Sign in via your SendHub username and password
   * @summary Sign in via your SendHub username and password
   * @param {LoginPayload1} [loginPayload1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  login(
    loginPayload1?: LoginPayload1,
    options?: any
  ): AxiosPromise<TokenPairResponse>

  /**
   * Sign out of SendHub Integrations (and optionally, app.SendHub.com)
   * @summary Sign out of SendHub Integrations (and optionally, app.SendHub.com)
   * @param {LogoutPayload1} [logoutPayload1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  logout(logoutPayload1?: LogoutPayload1, options?: any): AxiosPromise<void>

  /**
   * Handles 3rd-party webhooks
   * @param {string} registeredWebhookId ID of the RegisteredWebhook
   * @param {WebhookBody} [webhookBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  postWebhook(
    registeredWebhookId: string,
    webhookBody?: WebhookBody,
    options?: any
  ): AxiosPromise<void>

  /**
   * Refresh your Access Token
   * @summary Refresh your Access Token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  refreshToken(options?: any): AxiosPromise<TokenPairResponse>

  /**
   * Submit a New Integration Request with the required fields
   * @summary Submit a New Integration Request
   * @param {NewIntegrationFormPayload} newIntegrationFormPayload
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  requestIntegration(
    newIntegrationFormPayload: NewIntegrationFormPayload,
    options?: any
  ): AxiosPromise<NewIntegrationFormResponse>

  /**
   * Sign in via your existing SendHub session!
   * @summary Sign in via your existing SendHub session!
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  sso(options?: any): AxiosPromise<TokenPairResponse>

  /**
   * Update an IntegrationConfig
   * @param {string} integrationConfigId ID of the IntegrationConfig
   * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  updateIntegrationConfig(
    integrationConfigId: string,
    integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
    options?: any
  ): AxiosPromise<IntegrationConfig>

  /**
   * Update an ServiceAccount
   * @param {string} serviceAccountId ID of the ServiceAccount
   * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApiInterface
   */
  updateServiceAccount(
    serviceAccountId: string,
    serviceAccountCreationPayload?: ServiceAccountCreationPayload,
    options?: any
  ): AxiosPromise<ServiceAccount>
}

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI implements DefaultApiInterface {
  /**
   * Creates an IntegrationConfig
   * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createIntegrationConfig(
    integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
    options?: any
  ) {
    return DefaultApiFp(this.configuration)
      .createIntegrationConfig(integrationConfigCreationPayload, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Creates an ServiceAccount
   * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createServiceAccount(
    serviceAccountCreationPayload?: ServiceAccountCreationPayload,
    options?: any
  ) {
    return DefaultApiFp(this.configuration)
      .createServiceAccount(serviceAccountCreationPayload, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Delete a ServiceAccount. Turns off and unlinks every IntegrationConfig using it, removes its webhooks in the third-party service, and wipes the stored credentials.
   * @summary Delete Service Account
   * @param {string} serviceAccountId ID of the ServiceAccount
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteServiceAccount(serviceAccountId: string, options?: any) {
    return DefaultApiFp(this.configuration)
      .deleteServiceAccount(serviceAccountId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get Integration
   * @summary Your GET endpoint
   * @param {string} integrationId ID of the integration
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getIntegration(integrationId: string, options?: any) {
    return DefaultApiFp(this.configuration)
      .getIntegration(integrationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get an IntegrationConfig
   * @summary Your GET endpoint
   * @param {string} integrationConfigId ID of the IntegrationConfig
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getIntegrationConfig(integrationConfigId: string, options?: any) {
    return DefaultApiFp(this.configuration)
      .getIntegrationConfig(integrationConfigId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get IntegrationGroup
   * @summary Get Integration Group
   * @param {string} integrationGroupId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getIntegrationGroup(integrationGroupId: string, options?: any) {
    return DefaultApiFp(this.configuration)
      .getIntegrationGroup(integrationGroupId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a ServiceAccount
   * @summary Get Service Account by ID
   * @param {string} serviceAccountId ID of the ServiceAccount
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getServiceAccount(serviceAccountId: string, options?: any) {
    return DefaultApiFp(this.configuration)
      .getServiceAccount(serviceAccountId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get Zapier Profile
   * @summary Get Zapier Profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getZapierProfile(options?: any) {
    return DefaultApiFp(this.configuration)
      .getZapierProfile(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List IntegrationConfigs
   * @summary Your GET endpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public listIntegrationConfigs(options?: any) {
    return DefaultApiFp(this.configuration)
      .listIntegrationConfigs(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List IntegrationGroups
   * @summary List Integration Groups
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public listIntegrationGroups(options?: any) {
    return DefaultApiFp(this.configuration)
      .listIntegrationGroups(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Lists Integrations
   * @summary Your GET endpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public listIntegrations(options?: any) {
    return DefaultApiFp(this.configuration)
      .listIntegrations(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List ServiceAccounts
   * @summary Your GET endpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public listServiceAccounts(options?: any) {
    return DefaultApiFp(this.configuration)
      .listServiceAccounts(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List Zapier Apps
   * @summary List Zapier Apps
   * @param {number} [perPage] (defaults to 100, max of 100) Limit the number of apps returned.
   * @param {number} [page] (defaults to 1) The page number. Page number 1 refers to the first page in the result.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public listZapierApps(perPage?: number, page?: number, options?: any) {
    return DefaultApiFp(this.configuration)
      .listZapierApps(perPage, page, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List Zapier Zap Templates
   * @summary List Zap templates
   * @param {string} [templates] A comma separated list of specific Zap templates.
   * @param {string} [apps] A comma separated list of Zapier Apps to match Zap templates against. *Note: SendHub will always be one of the apps.*
   * @param {number} [limit] (defaults to 5, max of 100) Limit the number of Zap templates returned.
   * @param {number} [offset] (defaults to 0) The number of Zap templates to skip before beginning to return the Zap templates. The default value is 0, which is the offset of the first item.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public listZapierTemplates(
    templates?: string,
    apps?: string,
    limit?: number,
    offset?: number,
    options?: any
  ) {
    return DefaultApiFp(this.configuration)
      .listZapierTemplates(templates, apps, limit, offset, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List Zapier Zaps
   * @summary List Zapier Zaps
   * @param {number} [limit] (defaults to 5, max of 100) Limits the number of returned items
   * @param {number} [offset] (defaults to 0) the number of Zaps to skip before beginning to return the Zaps. The default value of 0, which is the offset of the first item.
   * @param {{ [key: string]: string; }} [params] Return Zaps that have a specific key/value set in the params (settings) of the Zap.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public listZapierZaps(
    limit?: number,
    offset?: number,
    params?: { [key: string]: string },
    options?: any
  ) {
    return DefaultApiFp(this.configuration)
      .listZapierZaps(limit, offset, params, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sign in via your SendHub username and password
   * @summary Sign in via your SendHub username and password
   * @param {LoginPayload1} [loginPayload1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public login(loginPayload1?: LoginPayload1, options?: any) {
    return DefaultApiFp(this.configuration)
      .login(loginPayload1, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sign out of SendHub Integrations (and optionally, app.SendHub.com)
   * @summary Sign out of SendHub Integrations (and optionally, app.SendHub.com)
   * @param {LogoutPayload1} [logoutPayload1]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public logout(logoutPayload1?: LogoutPayload1, options?: any) {
    return DefaultApiFp(this.configuration)
      .logout(logoutPayload1, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Handles 3rd-party webhooks
   * @param {string} registeredWebhookId ID of the RegisteredWebhook
   * @param {WebhookBody} [webhookBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhook(
    registeredWebhookId: string,
    webhookBody?: WebhookBody,
    options?: any
  ) {
    return DefaultApiFp(this.configuration)
      .postWebhook(registeredWebhookId, webhookBody, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Refresh your Access Token
   * @summary Refresh your Access Token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public refreshToken(options?: any) {
    return DefaultApiFp(this.configuration)
      .refreshToken(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Submit a New Integration Request with the required fields
   * @summary Submit a New Integration Request
   * @param {NewIntegrationFormPayload} newIntegrationFormPayload
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public requestIntegration(
    newIntegrationFormPayload: NewIntegrationFormPayload,
    options?: any
  ) {
    return DefaultApiFp(this.configuration)
      .requestIntegration(newIntegrationFormPayload, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Sign in via your existing SendHub session!
   * @summary Sign in via your existing SendHub session!
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public sso(options?: any) {
    return DefaultApiFp(this.configuration)
      .sso(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an IntegrationConfig
   * @param {string} integrationConfigId ID of the IntegrationConfig
   * @param {IntegrationConfigCreationPayload} [integrationConfigCreationPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateIntegrationConfig(
    integrationConfigId: string,
    integrationConfigCreationPayload?: IntegrationConfigCreationPayload,
    options?: any
  ) {
    return DefaultApiFp(this.configuration)
      .updateIntegrationConfig(
        integrationConfigId,
        integrationConfigCreationPayload,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update an ServiceAccount
   * @param {string} serviceAccountId ID of the ServiceAccount
   * @param {ServiceAccountCreationPayload} [serviceAccountCreationPayload]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateServiceAccount(
    serviceAccountId: string,
    serviceAccountCreationPayload?: ServiceAccountCreationPayload,
    options?: any
  ) {
    return DefaultApiFp(this.configuration)
      .updateServiceAccount(
        serviceAccountId,
        serviceAccountCreationPayload,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}
